<template>
    <div>
      <BasicForm 
        :update="updateForm" 
        :saveFunc="save" 
        :cancelFunc="cancelFunc" 
        :form="form" 
        :$v="$v" 
        :formConfig="formConfig" 
        :recordData="recordData" 
        :headerColor="headerColor" 
        :filter="serviceAccountIdFilter"
        :accountServiceItems="this.accountServiceList"
        @selectedServices="onSelectedServices"
      ></BasicForm>

      <div class="md-autocomplete-loading" v-show="isPromisePending">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
      </div>

      <md-dialog-confirm
        :md-active.sync="confirmDialog.show"
        :md-title="confirmDialog.title"
        :md-content="confirmDialog.content"
        md-confirm-text="Yes"
        md-cancel-text="Cancel"
        @md-cancel="resetDialog"
        @md-confirm="removeChildren"
      />

      <!-- Required: PO Child level 1 -->
      <template v-if="childProductOptionsList.length">
            <h6 style="margin-bottom:0;">Add Dependencies...</h6>
            <ul class="po-required-products __productOption-ul" style="margin-top:0; margin-right:25px;">
                  <template v-for="(po, poIndex) in productOptionConfig">
                        <li :key="po.productProductOptionId + '_' + poIndex" v-if="po && (po.required || po.allowOptional) && po.name">
                              {{ po.name }}
                              <md-icon v-if="po.required" style="font-size: 15px !important; color: red;">warning</md-icon>
                              <md-button @click="removeChildL1(po.required, po.name, po.productProductOptionId, poIndex)" class="md-button md-button-tiny md-just-icon md-danger md-simple md-theme-default">
                                <md-icon style="color:#ff0000 !important;">close</md-icon>
                              </md-button>
                              
                              <!-- PO Child level 2 -->
                              <ul class="po-required-products __productOptionChild-ul"  style="margin-top:0;"
                                  v-if="po.children && po.children.length">
                                    <template v-for="(el, elIndex) in po.children">
                                    <li v-if="el && (el.required | el.allowOptional) && el.name" :key="el.productProductOptionId + '_' + elIndex" >
                                          {{ el.name }}
                                          <md-icon v-if="el.required" style="font-size: 15px !important; color: red;">warning</md-icon>
                                          <md-button @click="removeChildL2(el.required, el.name, po.productProductOptionId, poIndex, elIndex)" style="padding:5px;" class="md-button md-button-tiny md-just-icon md-danger md-simple md-theme-default">
                                            <md-icon style="color:red !important;">close</md-icon>
                                          </md-button>
                                    </li>
                                    </template>
                              </ul>
                              <md-field style="margin-left: 30px;">
                                    <label>Add Level 2</label>
                                    <md-select v-model="selectedChild[poIndex]">
                                          <md-option v-for="item in po.childItems" :value="item.productProductOptionId" :key="item.productProductOptionId + '_' + poIndex"> {{ item.name }} </md-option>
                                    </md-select>
                                    <md-button @click="addChildL2(poIndex)" class="md-button md-just-icon md-simple md-warning">
                                          <md-icon style="color:green !important;">add</md-icon>
                                    </md-button>
                              </md-field>
                        </li>
                  </template>
            </ul>
      </template>

      <!-- Optional: PO Child level 1 -->
      <template v-if="childProductOptionsList.length">
        <md-field>
          <label>Add Level 1</label>
          <md-select v-model="selectedChildL1">
              <md-option v-for="item in childProductOptionsList" :value="item.id" :key="item.id"> {{ item.child.name }} </md-option>
          </md-select>
          <md-button @click="addChildL1()" class="md-button md-just-icon md-simple md-warning">
              <md-icon style="color:green !important;">add</md-icon>
          </md-button>
        </md-field>
      </template>

      <CrudToolbar :save="save" :form="form" :$v="$v" :formConfig="formConfig" :cancel="cancelFunc"></CrudToolbar>
    </div>
</template>

<script>
  import Record from '@/mixins/Record';
  import BasicForm from '@/components/DynamicForm/BasicForm';
  import CrudToolbar from '@/components/Crud/Toolbar';

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";
  import {API, graphqlOperation} from "aws-amplify";
  import * as queries from '@/graphql/queries';
  import * as queries_custom from '@/graphql/queries_custom';
  import * as mutations from '@/graphql/mutations';

  export default {
    name: "product",
    mixins: [Record],
    components: {
      BasicForm,
      CrudToolbar
    },
    props: {
      productAccountId: {
        type: String,
        required: true
      },
      productsList: {
        type: Object,
        required: true
      },
      productAccountAlert: {
        required: true
      },
      loadProductOptions: {
        type: Array,
        required: false
      },
      selectDefaultCategory: {
        type: String,
        required: false
      }
    },
    computed: {
      caseServiceRelateRecordInput: function() { return {'caseProductCaseId': null, 'caseProductProductId': this.$route.params.id}},
      caseProductIdFilter: function() { return {"caseProductProductId": {"eq": this.$route.params.id }}; },
      serviceAccountIdFilter: function () { return [{"match": {"serviceAccountId.keyword": this.form.productAccountId }}] },
      taskProductIdFilter: function() { return {"taskProductProductId": {"eq": this.$route.params.id }}; }
    },

    data() {
      return {
        noticationTimeStamp: [],
        removeChild : '',
        poId : null,
        parentIndex : null,
        childIndex : null,
        confirmDialog: {
          'show': false,
          'content': "",
          'title': ""
        },
        childProductOptionsList: [],
        productOptionConfig: [],
        categoryOptions: [],
        productOptions: [],
        isPromisePending: false,
        selectedChildL1: "",
        selectedChild: {},
        accountServiceList: [],
        selectedServiceIds: [],
        createdProductIds: [],
        gql: {
          queries: queries,
          queries_custom: queries_custom,
          mutations: mutations,
        },
        formConfig: {
          responseFieldName: 'getProduct',
          removeFields: ['services','children'],
          actions: {
            save: 'createProduct',
            view: 'getProduct',
            edit: 'editProduct',
            new: 'newProduct',
            update: 'updateProduct',
            delete: 'deleteProduct',
          },
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":12,"i":"0"}},
          },
          listPath: "/products",
          headerIcon: 'devices',
          objectName: 'Product',
          objectNamePlural: 'Products',
          editMode: false,
          removeField: "category",  // can be remove the form field
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          fields: {
            id: { label: "ID", type: "id", slot: 'basic' },
            productAccountId: { label: "Account", type: "autocomplete", slot: 'basic',
              data: [],
              searchTerm: "",
              options: [],
              linkBase: '#/accounts/',
              setVal: (val) => {
                this.$v.form.productAccountId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.name;
              })(this.formConfig.fields.productAccountId)},
              change: (search) => {(($this) => {
                const data = $this.data;
                $this.options = new Promise(resolve => {
                  window.setTimeout(() => {
                    if (!search) {
                      $this.setVal("");
                      $this.searchTerm = "";
                      resolve(data)
                    } else {
                      const term = search.toLowerCase();
                      let result = data.filter(({ name }) => name.toLowerCase() === term);
                      if (result.length) {
                        $this.select(result[0]);
                      } else {
                        $this.setVal("");
                        $this.searchTerm = "";
                      }
                      resolve(data.filter(({ name }) => name.toLowerCase().includes(term)));
                    }
                  }, 100)
                })
              })(this.formConfig.fields.productAccountId)}
            },
            serviceList: {
              label: "Services",
              type: "listControl",
              slot: "basic",
            },
            category: {
              label: "Category",
              type: "select",
              slot: 'basic',
              options: [],
              optionType: 'enum',
              hide: () => {
                return (this.selectDefaultCategory && this.selectDefaultCategory != '');
              }
            },
            //productProductOptionId: {label: "Product Option", type: "select", slot: "basic", options: [], optionType: 'enum' },
            // specifying non-existent slot will provide hidden input functionality
            productProductOptionId: {
              label: "Product Option",
              type: "autocomplete",
              slot: "basic",
              data: [],
              searchTerm: "",
              options: [],
              linkBase: "#/productoptions/",
              setVal: (val) => {
                this.$v.form.productProductOptionId.$model = val;
              },
              select: (c) => {
                (($this) => {
                  $this.setVal(c.id);
                  $this.searchTerm = c.name;
                })(this.formConfig.fields.productProductOptionId);
              },
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: "searchProductOptions",
              lazyLoadResponseFieldName: "searchProductOptions",
              lazyLoadSearchableFields: ["name"],
              lazyLoadFilter: null,
              hide: () => {
                return !this.form || !this.form.category;
              },
            },
            status: { label: "Status", type: "switch", slot: 'file_build_info', value: true },
          },
          editTitleField: 'name'
        },
        form: {
          id: "",
          productAccountId: "",
          category: "",
          productProductOptionId: "",
          status: true,
          serviceList: "",
        },
      }
    },
    watch: {
      /**
       * ATLAS-1395: <Account/Service><Products> Update Add Product Dialog New
       * Get list of services for selected Account
       */
      "form.productAccountId": {
        immediate: true,
        handler: function(newVal, oldVal) {
          if (newVal && oldVal !== newVal) {
            this.getAccountServices(newVal);
          }
        }
      },
      "form.category": {
        immediate: true,
        handler: function(newVal, oldVal) {
          (($this) => {
              if (newVal && oldVal !== newVal) {
                  $this.searchTerm = '';
                  this.form.productProductOptionId = '';

                  console.log('category updated', this.form.category);

                  let newPOList = [];
                  const origPOList = this.form.productOptionsList;
                  origPOList.forEach((_element, _elementIndex) => {
                      //console.log("_element", _element)
                      if (_element.category === this.form.category) {
                          newPOList.push({
                              id: _element.id,
                              name: _element.name.replace(/\_/g, ' '),
                          });
                      }
                  });
                  $this.options = newPOList;
                  //add filter on ProductOption field based on changed Category
                  this.formConfig.fields.productProductOptionId.lazyLoadFilter = {
                    bool: {
                      should: [
                        {
                          match_phrase: {
                            category: newVal,
                          },
                        },
                      ],
                    },
                  };
                  //this.$v.form.productProductOptionId.$model = '';
                  //this.form.childProductOptionsList = [];
              }
          })(this.formConfig.fields.productProductOptionId);
        }
      },
      /**
       * ATLAS-624 Product Dependencies - part 2 -
       * Require product selection on front end based on dependencies
       *
       * Get child items for selected ProductOption to pass SearchModalParentChild CRUD input
       */
      // "$v.form.productProductOptionId.$model": {
      "form.productProductOptionId": {
        immediate: true,
        handler: function() {
          let POList = [];
          if (this.form.productProductOptionId) {

            const origPOList = this.form.productOptionsList;
            origPOList.forEach ((_element, _elementIndex) => {
              if(
                _element.id == this.form.productProductOptionId &&
                _element.children && _element.children.items &&
                _element.children.items.length
              ) {
                POList = _element.children.items;
              }
            });

            //Add any required items down the tree to our productConfig to get started

            //Reset the base productOptionConfig here
            this.productOptionConfig = [];
            let L1data, L2data;
            POList.forEach(L1Item => {

                  if (L1Item.required) {

                        L1data = {
                              name: L1Item.child.name,
                              productProductOptionId: L1Item.child.id,
                              status: true,
                              productAccountId: this.form.productAccountId,
                              required: L1Item.required,
                              children: [],
                              childItems: []
                        };

                        if (L1Item.child.children && L1Item.child.children.items) {
                              L1Item.child.children.items.forEach(L2Item => {
                                  L2data = {
                                      name: L2Item.child.name,
                                      productProductOptionId: L2Item.child.id,
                                      status: true,
                                      productAccountId: this.form.productAccountId,
                                      required: L2Item.required
                                  };
                                  if(L2Item.required) {
                                      //add only required child in default productOptionConfig
                                      L1data.children.push(L2data);
                                  }
                                  L1data.childItems.push(L2data);
                              });
                        }
                        this.productOptionConfig.push(L1data);
                  }
            });
            console.log('this.productOptionConfig', this.productOptionConfig)
          }
          this.childProductOptionsList = POList;
          console.log('this.childProductOptionsList', this.childProductOptionsList)
        }
      }
    },
    validations() {
      return {
        form: {
          id: {},
          //name: {required, minLength: minLength(3)},
          productAccountId: {required},
          category: !this.selectDefaultCategory ? {required} : {},
          productProductOptionId: {required},
          // productServiceId: {},
          services: {},
          children: {},
          status: {},
          serviceList: {},
          // productBillToServiceId: (this.form && (this.form.category === 'PMS_or_POS' || this.form.category === 'Terminal')) ? {required} : {},
        },
      }
    },
    methods: {
      updateFormAfter(data) {
        if (typeof data === 'undefined') return;

        //set pageMode to edit if dialog opened from Product Sidepanel
        if (this.selectDefaultCategory) {
          this.$set(this.formConfig, 'pageMode', 'edit');
          //set category
          this.form.category = this.selectDefaultCategory;
        }

        // Configure the Account field
        (($this) => {
          $this.data = data.listAccounts.items;

          /**
           * ATLAS-1262: <DM> <Account> Product tab: After creating a new account, 
           * product records added automatically in Product tab
           * 
           * Add Product's account entry in the Accounts list
           * if not exist in query result - data.listAccounts.items
           * 
           * Get productsList.addProductAccountInModal from Account -> Products tab -> ADD &
           * Product Sidepanel -> Dependencies -> ADD
           */
          let isSetProductAccount = true;
          let productAccountObj = {};
          data.listAccounts.items.forEach(el => {
            if (el.id === this.productAccountId) {
              isSetProductAccount = false;
            }
          });

          if (isSetProductAccount) {
            if (this.productsList && this.productsList.addProductAccountInModal) {
              productAccountObj = {
                id: this.productsList.addProductAccountInModal.id,
                name: this.productsList.addProductAccountInModal.name
              };
              console.log(productAccountObj);
              $this.data.push(productAccountObj);
            }
          }

          if (this.productAccountId) {
            $this.data.forEach(item => {
              if(item.id == this.productAccountId) {
                $this.searchTerm = item.name;
                this.form.productAccountId = item.id;
              }
            });
          }
        })(this.formConfig.fields.productAccountId);

        // Configure the Category field
        (($this) => {
          this.categoryOptions = [];
          if (data.listProductCategoryEnum && data.listProductCategoryEnum.enumValues) {
            data.listProductCategoryEnum.enumValues.map(_value => {
              this.categoryOptions.push({
                id: _value.name,
                name: _value.name.replace(/\_/g, ' '),
              });
            });
          }
          $this.options = this.categoryOptions;
        })(this.formConfig.fields.category);

        // Configure Product Option field
        (($this) => {
          $this.data = data.listProductOptions.items;
          this.productOptions = [];
          //form options from listProductOptions query
          if (data.listProductOptions && data.listProductOptions.items) {
            data.listProductOptions.items.map(_value => {
              this.productOptions.push({
                id: _value.id,
                name: _value.name.replace(/\_/g, ' '),
              });
            });
          }

          /**
           * ATLAS-1012: <Product/Product Option> <Side Panel> Product Dependencies
           * load specific ProductOptions
           */
          if (this.loadProductOptions && this.loadProductOptions.length) {
            let loadOptions = [];
            this.productOptions.map(_po => {
              if (this.loadProductOptions.includes(_po.id)) {
                loadOptions.push(_po);
              }
            });

            /**
             * ATLAS-1293: <DM> On Product details side panel - Dependencies section
             * sometime LINK button popup not showing records
             */
            if (loadOptions.length === 0 && this.selectDefaultCategory) {
              this.loadProductOptions.forEach(el => {
                this.productOptions.push(el);
              });
              $this.options = this.loadProductOptions;
            } else {
              $this.options = loadOptions;
            }
          } else {
            $this.options = this.productOptions;
          }

          this.form.productOptionsList = $this.data;
          $this.data = [];
        })(this.formConfig.fields.productProductOptionId);
      },
      cancelFunc() {
        this.isPromisePending = false;
        this.productsList.showAddNewModal = false;
        //this.productsList.needsRefresh = true;
      },
      async save() {
        this.isPromisePending = true;
        this.$v.$touch();
        if(this.$v.form.$invalid) {
          this.$c.log('save(): unable to save, $v.invalid');
          this.isPromisePending = false;
          return;
        }

        let data = {};
        const form = this.form;
        const fields = this.formConfig.fields;

        this.$loopo(fields, (field, name) => {
          if (!field.fields) {
            if (typeof form[name] !== 'undefined' && form[name] !== null) {
              if (field.type === 'datepicker') {
                try{
                  data[name] = form[name].toUTCString();
                }catch (e) {
                  data[name] = form[name].toString();
                  console.log('datepicker try catch ',form[name])
                }
              } else {
                data[name] = form[name];
              }
            }
          } else {
            if (field.type === 'json') {
              const jsonFields = form[name].fields;
              Object.keys(jsonFields).map(_key => {
                if (field.fields && field.fields[_key] && field.fields[_key].removeIfEmpty) {
                  if (!jsonFields[_key] || !jsonFields[_key].toString().length) {
                    delete(jsonFields[_key]);
                  }
                }
              });
              data[name] = JSON.stringify(jsonFields);
            }
          }
        });

        let matches = this.productOptions.filter(option => option.id === data.productProductOptionId);
        data['name'] = matches.length ? matches[0].name : '';

        // We should not send any empty strings on create
        if (this.formConfig.pageMode == 'new') {
          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "") {
                delete data[name];
              }
              // remove the form field which should not actually be stored in schema model record.
              if (this.formConfig.removeField) {
                delete data[this.formConfig.removeField];
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  delete data[name];
                }
              }
            }
          });
        }

        if (this.formConfig.pageMode == 'edit') {
          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "" || data[name] === undefined) {
                data[name] = null;
              }
              // remove the form field which should not actually be stored in schema model record.
              if (this.formConfig.removeField) {
                delete data[this.formConfig.removeField];
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  data[name] = null;
                }
              }
            }
          });
        }

        if (this.formConfig.removeFields && this.formConfig.removeFields.length) {
          this.formConfig.removeFields.forEach(item => {
            delete data[item];
          });
        }

        //added check for ATLAS-1012: <Product> <Side Panel> Product Dependencies
        if(data && data.id) {
          delete data.id;
        }
        //added check for ATLAS-1395: <Account/Service><Products> Update Add Product Dialog New
        if (data && data.serviceList == null) {
          delete data.serviceList;
        }

        this.$c.log('data has been prepared form=', data);

        const productResponse = await this.createProduct(data);

        if (productResponse && this.productOptionConfig.length) {

              this.createL0ProductChild(productResponse);

              //loop through productOptionConfig and create products(s) & ProductChild(s)
              for (const L1Product of this.productOptionConfig) {
                    const children = L1Product.children;
                    delete(L1Product.children);

                    //delete additional fields
                    delete(L1Product.childItems);
                    if(L1Product.allowOptional) {
                      delete(L1Product.allowOptional);
                    }
                    //required field not to be saved from createProduct mutation
                    delete(L1Product.required);

                    const L1ProductResponse = await this.createProduct(L1Product);
                    if (L1ProductResponse) {
                          console.log('L1ProductResponse: ', L1ProductResponse)
                          //Insert a ProductChildRecord here
                          const L1ProductChildResponse = await this.createProductChild({
                                parentId: productResponse.id,
                                productChildChildId: L1ProductResponse.id
                          });

                          console.log('L1ProductChildResponse: ', L1ProductChildResponse)

                          if (children.length) {

                                for (const L2Product of children) {
                                      //required field not to be saved from createProduct mutation
                                      delete(L2Product.required);
                                      if(L2Product.allowOptional) {
                                            delete(L2Product.allowOptional);
                                      }

                                      //Insert a Product Record
                                      const L2ProductResponse = await this.createProduct(L2Product);
                                      if (L2ProductResponse) {
                                            console.log('L2ProductResponse: ', L2ProductResponse)
                                            //Insert a ProductChildRecord
                                            const L2ProductChildResponse = await this.createProductChild({
                                                  parentId: L1ProductResponse.id,
                                                  productChildChildId: L2ProductResponse.id
                                            });
                                            console.log('L2ProductChildResponse: ', L2ProductChildResponse)

                                      }
                                }

                          }
                    }
              }
        } else {
              this.createL0ProductChild(productResponse);
        }

        if (this.createdProductIds) {
          const productServiceResponse = await this.createProductService();
          console.log("productServiceResponse: ", productServiceResponse);
        }

        this.noticationTimeStamp = [];

        if (this.productAccountAlert) {
          let timeStamp = this.$notify({
            title: "Account Alert",
            message: this.productAccountAlert,
            icon: "work",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            timeout: 10000
          });
          this.noticationTimeStamp.push(timeStamp);
        }

        this.cancelFunc();
      },
      async createProduct(data) {
            let result = false;
            let query = this.getMutation('createProduct');
            await API.graphql(graphqlOperation(query, {input: data}))
              .then(response => {
                    result = response.data.createProduct;
                    //add productIds to array
                    this.createdProductIds.push(result.id);
              })
              .catch(error => {
                    this.$c.log(error);
                    this.$set(this.formConfig, 'formErrors', error);
              });
            return result;
      },
      async createProductChild(data) {
            let result = false;
            let query = this.getMutation('createProductChild');
            await API.graphql(graphqlOperation(query, {input: data}))
              .then(response => {
                    result = response.data.createProductChild;
              })
              .catch(error => {
                    this.$c.log(error);
                    this.$set(this.formConfig, 'formErrors', error);
              });
            return result;
      },
      getMutation(name) {
        let result = false;
        if (name) {
          if (typeof this.gql.mutations[name] !== 'undefined') {
            result = this.gql.mutations[name];
          }
        }
        return result;
      },
      /**
       * ATLAS-1012: <Product/Product Option><Side Panel> Product Dependencies
       * Insert a ProductChildRecord for parent PO only
       */
      async createL0ProductChild(productResponse) {
            if (this.$route && this.$route.path && this.$route.path.startsWith("/products")) {
                  const L0ProductChildResponse = await this.createProductChild({
                        parentId: this.$route.params.id,
                        productChildChildId: productResponse.id
                  });
                  console.log('L0ProductChildResponse: ', L0ProductChildResponse);
            }
      },

      /**
       * ATLAS-1395: <Account/Service><Products> Update Add Product Dialog New
       * Create ProductService record
       */
      createProductService() {
        let promiseArr = [];
        this.selectedServiceIds.forEach(elem => {
          this.createdProductIds.forEach(el => {
            let input = {
              productServiceProductId: el,
              productServiceServiceId: elem.id
            }

            let query = this.getMutation('createProductService');
            let gqlRequest = API.graphql(graphqlOperation(query, {input: input}));
            promiseArr.push(gqlRequest);
          });
        });
        //this.createdProductIds
        Promise.allSettled(promiseArr).then((resultPromise) => {
          this.$c.log('ProductService records created Successfully');
        });
      },
      loadRelatedRecords(data, name, target) {
        let result = [];
        if (data && data.getProduct && data.getProduct[name] && data.getProduct[name].items && data.getProduct[name].items.length) {
          let items = data.getProduct[name].items;
          items.forEach(item => {
            if(item[target]){
              item[target].relateRecordId = item.id;
              result.push(item[target]);
            }

          });
        }
        this.form[name] = result;
      },

      getCategoryEnumOptions(data) {
        this.categoryOptions = [];
        if (data.listProductCategoryEnum && data.listProductCategoryEnum.enumValues) {
          data.listProductCategoryEnum.enumValues.map(_value => {
            this.categoryOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.category.options = this.categoryOptions;
        }
      },

      /**
       * Loop through childProductOptionsList to match selected L1 child &
       * add it into productOptionConfig along with it's children item
       */
      addChildL1() {
        this.childProductOptionsList.forEach((el, idx) => {
          
          if (el.id == this.selectedChildL1) {
            let L1data, L2data;
            L1data = {
              name: el.child.name,
              productProductOptionId: el.child.id,
              status: true,
              productAccountId: this.form.productAccountId,
              required: el.required,
              children: [],
              childItems: [],
              allowOptional: true
            };

            if (el.child.children && el.child.children.items) {
              el.child.children.items.forEach(L2Item => {
                L2data = {
                  name: L2Item.child.name,
                  productProductOptionId: L2Item.child.id,
                  status: true,
                  productAccountId: this.form.productAccountId,
                  required: L2Item.required
                };

                //if L2 Product Option is required
                if (L2Item.required) {
                  L1data.children.push(L2data);
                }

                //add required/optional L2 child for Add Level 2 dropdown
                L1data.childItems.push(L2data);
              });
            }

            //add optional L1 child only when L2 children have required = true
            if(L1data.allowOptional) {
              this.productOptionConfig.push(L1data);
            }
          }
        });
        //reset option
        this.selectedChildL1 = "";
      },
      /**
       * Match L1 child PO & remove it from template
       */
      removeChildL1(required, name, poId, poIndex) {
        if(required) {
          this.confirmDialog.show = true;
          this.confirmDialog.title = 'Are you sure you want to remove the required L1 child Product Option '+ name +'?';
          this.confirmDialog.content = '';
          this.removeChild = 'L1';
          this.poId = poId;
          this.poIndex = poIndex;
        } else{
          this.productOptionConfig.forEach((el, idx) => {
            if(el.productProductOptionId == poId) {
              this.productOptionConfig.splice(poIndex, 1);
            }
          })
        }
        
      },
      /**
       * Loop through productOptionConfig to match selected L2 required child &
       * add it into productOptionConfig L2 children array
       */
      addChildL2(poIndex) {
        let poConfig = this.productOptionConfig[poIndex];

        poConfig.childItems.forEach((e, i) => {
          if(e.productProductOptionId == this.selectedChild[poIndex]) {
            //if L2 child is optional
            if(!e.required) {
              e.allowOptional = true;
            }
            poConfig.children.push(e);

            //reset option
            this.selectedChild[poIndex] = "";
          }
        });
      },
      /**
       * Match L2 child PO & remove it from template
       */
      removeChildL2(required, name, poId, parentIndex, childIndex) {
        if(required) {
          this.confirmDialog.show = true;
          this.confirmDialog.title = 'Are you sure you want to remove the required L2 child Product Option '+ name +'?';
          this.confirmDialog.content = '';
          this.removeChild = 'L2';
          this.poId = poId;
          this.parentIndex = parentIndex;
          this.childIndex = childIndex;
        } else {
          let poConfig = this.productOptionConfig[parentIndex];

          //match L1 PO
          if(poConfig.productProductOptionId == poId) {
            if(poConfig.children && poConfig.children.length) {
              poConfig.children.splice(childIndex, 1);
            }
          }
        }
      },

      removeChildren() {
        if (this.removeChild == 'L1') {
          this.productOptionConfig.forEach((el, idx) => {
            if(el.productProductOptionId == this.poId) {
              this.productOptionConfig.splice(this.poIndex, 1);
            }
          })
        } else if (this.removeChild == 'L2') {
          let poConfig = this.productOptionConfig[this.parentIndex];
          //match L1 PO
          if(poConfig.productProductOptionId == this.poId) {
            if(poConfig.children && poConfig.children.length) {
              poConfig.children.splice(this.childIndex, 1);
            }
          }
        }
        this.resetDialog();
      },
      resetDialog() {
        this.confirmDialog.title = '';
        this.confirmDialog.content = '';
        this.confirmDialog.item = false;
      },
      /**
       * ATLAS-1395: <Account/Service><Products> Update Add Product Dialog New
       */
      async getAccountServices(accountId) {
        let params = {};
        params.limit = 999;
        params.filter = { serviceAccountId: {matchPhrase: accountId} };

        //searchAccountServiceCustoms
        const result = await API.graphql(graphqlOperation(queries_custom["searchAccountServiceCustoms"], params))
        .then(result => {
          //console.log("result: ", result);
          this.accountServiceList.splice(0, this.accountServiceList.length);
          if (result && result.data.searchServices && result.data.searchServices.items) {
            this.accountServiceList.push(result.data.searchServices.items);
          }
        })
        .catch(error => {
          console.log(error);
        });
      },
      onSelectedServices(serviceIds) {
        this.selectedServiceIds = serviceIds;
      }
    }
  }
</script>

<style lang="scss">
  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;

    .md-tab-nav-button.md-button {
      color: black !important;

      &.active {
        color: black !important;
        border-bottom: 2px solid black;
      }
    }
  }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

  [name="giftCardProvider"] {
    margin-top: 16px;
  }

  .form-field-view.search-modal-header {
    font-weight: 500;
  }

  .isEditing .form-field-view.search-modal-header {
    font-weight: normal;
  }

  .md-dialog.__customize.md-dialog-fullscreen.md-theme-default{
    max-width: 780px;
  }

  .md-progress-spinner {
    position: fixed;
  }
</style>
